import { render, staticRenderFns } from "./ListPage.vue?vue&type=template&id=38467350&scoped=true&"
import script from "./ListPage.vue?vue&type=script&lang=ts&"
export * from "./ListPage.vue?vue&type=script&lang=ts&"
import style0 from "./ListPage.vue?vue&type=style&index=0&id=38467350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38467350",
  null
  
)

export default component.exports